import React from "react";
import { LabelText, TitleText } from "../ui/Text";
import styled from "styled-components";

export interface PerspectiveCard {
  title: string;
  value: number;
  color: string;
  icon: JSX.Element;
}
export const PerspectiveCard = ({
  color,
  icon,
  title,
  value,
}: PerspectiveCard) => {
  return (
    <Card>
      <LabelText>{title}</LabelText>
      <TitleText>
        {value}
        <Indicator color={color} />
      </TitleText>
      <CardIconContainer>{icon}</CardIconContainer>
    </Card>
  );
};
const Card = styled.div`
  background-color: #fff;
  display: grid;
  grid-template-columns: 4fr 1fr;
  grid-template-rows: 1fr 1fr;
  align-items: center;
  padding: 0.2em 1.1em;
  border-radius: 8px;
  color: #214160;
  margin: none;
  ${LabelText} {
    color: #214160;
  }
  ${TitleText} {
    font-size: 24px;
    margin: 0;
    display: flex;
  }
`;

const Indicator = styled.div<{ color: string }>`
  height: 0.25em;
  width: 0.25em;
  margin-left: 0.25em;
  background-color: ${(props) => props.color};
  border-radius: 0.5em;
`;

const CardIconContainer = styled.div`
  height: 1.5em;
  width: 1.5em;
  display: grid;
  grid-row-start: 1;
  grid-row-end: 3;
  grid-column-start: 2;
  grid-column-end: 3;
  border: 1px solid #d9dfff;
  justify-items: center;
  align-items: center;
  border-radius: 5px;
`;
